import React, { useEffect, useMemo } from 'react';
import logo from 'assets/images/logo.svg';
import { RenderRawHTML, useOverlayToggle } from '@ace/react-utilities';
import { IconAngleRight } from '@ace/react-icons';
import UserBadge from 'Components/UserBadge';
import RefreshLink from 'Components/RefreshLink';
import buttonStyles from 'assets/css/Button.module.css';
import userBadgeStyles from 'assets/css/UserBadge.module.css';
import { DashboardComponentName } from 'Components/Dashboard/DashboardHelper';
import { CardLinkIconWrap } from 'Components/Card/CardLink';
import useSMARTGoalOverlay from 'context/SMARTGoalOverlayContext';

const DashboardHeader = ({content}) => {
    const { showOverlay, toggleOverlay, overlayRef } = useOverlayToggle();

    useEffect(() => {
        document.getElementsByTagName('title')[0].innerHTML = `ACE ${content.DashboardTitle}`;
    }, [content.DashboardTitle]);

    return (
        <>
            {useMemo(() => (<DashboardHeaderContent content={content} toggleUserMenu={toggleOverlay} />), [content, toggleOverlay])}
            {showOverlay ? <UserBadgeMenu ref={overlayRef} dashboardShortTitle={content.DashboardShortTitle} dashboardVariantCallToAction={content.DashboardVariantCallToAction} /> : false} 
        </>
    );
}

function getUserBadgeStyle(className) {
    return userBadgeStyles[className];
}

function SMARTGoalsOverlayButton(props) {
    const { toggleSMARTGoalsOverlay } = useSMARTGoalOverlay();

    return (
        <span className={buttonStyles.floating} onClick={() => toggleSMARTGoalsOverlay()}>
            Launch SMART Goals
            <CardLinkIconWrap>
                <IconAngleRight />
            </CardLinkIconWrap>
        </span>
    );
}

const DashboardHeaderContent = ({content, toggleUserMenu}) => {
    return (
        <header className="app-header">
            <section className="app-header__inner">
                <img src={logo} className="app-header__logo" alt="logo" />

                <h1 className="app-header__title">
                    {content.DashboardTitle}
                </h1>

                {useMemo(() => {
                    if (process.env.REACT_APP_ENABLE_DEV_LINKS === 'true') {
                        return (
                            <div>
                                <RefreshLink componentName={DashboardComponentName} linkText=" Dashboard" />
                                {/* TODO: refactor CardCenter to TabCenter */}
                                <RefreshLink componentName="CardCenter" linkText=" CardCenter" />
                                <RefreshLink componentName="MessageCenter" linkText=" MessageCenter" />
                                <SMARTGoalsOverlayButton />
                            </div>
                        );
                    }
                    return false;
                }, [])}

                {RenderRawHTML(content.DashboardVariantUpgradeCallOut)}

                {useMemo(() => (<div className="user-badge-wrap">
                    <UserBadge toggleUserMenu={toggleUserMenu} />
                </div>), [toggleUserMenu])}

                <div className="app-header__cta" style={{ paddingLeft: "1rem"}}>
                    <a href="/myace/default.aspx" className={`${buttonStyles.strokeGreen} ${buttonStyles.stroke} ${buttonStyles.strokeTall}`}><span className={"hidden-mobile"}>Back to</span> MyACE</a>
                </div>
            </section>
        </header>
    );
}

const UserBadgeMenu = React.forwardRef((props, ref) => {
    const { dashboardVariantCallToAction, dashboardShortTitle } = props;

    const UserBadgeMenuContent = useMemo(
        () => (
            <div className={getUserBadgeStyle("user-badge-menu")} ref={ref}>
                <div className={getUserBadgeStyle("user-badge-menu__meta")}>
                    <h4 className={getUserBadgeStyle("user-badge-menu__title")}>Study Program</h4>
                    <h3 className={getUserBadgeStyle("user-badge-menu__sub-title")}>{dashboardShortTitle}</h3>
                    {dashboardVariantCallToAction ? <div className={getUserBadgeStyle("user-badge-menu__cta")}>{RenderRawHTML(dashboardVariantCallToAction)}</div> : false}
                </div>
                <span className={getUserBadgeStyle("user-badge-menu__hr")}></span>
                <div className={getUserBadgeStyle("user-badge-menu__links")}>
                    <a className={getUserBadgeStyle("user-badge-menu__link")} href="/myace/my-profile.aspx">My ACE Profile</a>
                </div>

            </div>
        ), [dashboardVariantCallToAction, dashboardShortTitle, ref]
    );

    return (
        <div className={`${getUserBadgeStyle("user-badge-menu-container")} ${getUserBadgeStyle("menu-active")}`}>
            {UserBadgeMenuContent}
        </div>
    );
});

export default DashboardHeader;
